/* eslint-disable no-underscore-dangle */
class BfvSearchresultProfiles {
  constructor(options = {}) {
    this.$root = options.element;
    this.$filterButtons = this.$root.querySelectorAll('.js-filter-button');
    this.filterClasses = [...this.$filterButtons].map(($button) => $button.id).filter((filterClass) => filterClass);
  }

  init() {
    this.__bindEvents();
  }

  __bindEvents() {
    [...this.$filterButtons].forEach(($button, index, $filterButtons) => {
      $button.addEventListener('click', () => {
        const isActive = $button.classList.contains('btn--active');

        this.filterClasses.forEach((filterClass) => this.$root.classList.remove(filterClass));
        $filterButtons.forEach(($filterButton) => $filterButton.classList.remove('btn--active'));
        $filterButtons.forEach(($filterButton) => $filterButton.classList.remove('btn--active-disabled'));

        if (!isActive && $button.id) {
          $button.classList.add('btn--active-disabled');
          this.$root.classList.add($button.id);
        } else {
          $filterButtons.filter(($filterButton) => !$filterButton.id)[0].classList.add('btn--active-disabled');
        }
      });
    });
  }
}

export default BfvSearchresultProfiles;
